import { Type } from "class-transformer";
import { IntegrationType } from "./queries/integrations-list.query-base";

export class IntegrationPostDTO {
	public name: string;
	public providerType: IntegrationType;
}

class IntegrationGetItemDTO {
	accountGuid: string;
	name: string;
	providerAccountName: string;
	providerType: IntegrationType;
	authenticationType: string;
	isActive: boolean;
	isConnected: boolean;
	lastSyncDate: Date;
	createdDate: Date;
	modifiedDate: Date;
}

export class IntegrationGetDataDTO {
	@Type(() => IntegrationGetItemDTO) public item: IntegrationGetItemDTO;
}

export class IntegrationGetDTO {
	@Type(() => IntegrationGetDataDTO) public data: IntegrationGetDataDTO;
}
